// Age utilities — compute decimal age, months, and formatted strings from a Date of Birth.
// Keeps the API contract numeric (`chronological_age` in decimal years) while letting the
// UI and PDF reports display "X years Y months (Z.ZZ years)".

export function monthsBetween(dob, now = new Date()) {
  if (!dob) return null;
  const d = dob instanceof Date ? dob : new Date(dob);
  if (isNaN(d.getTime())) return null;
  let months = (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth());
  if (now.getDate() < d.getDate()) months -= 1;
  return Math.max(0, months);
}

export function ageFromDOB(dob, now = new Date()) {
  const totalMonths = monthsBetween(dob, now);
  if (totalMonths == null) return null;
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  // Decimal years with full day resolution — more accurate than months/12
  const d = dob instanceof Date ? dob : new Date(dob);
  const ms = now.getTime() - d.getTime();
  const decimalYears = +(ms / (365.2425 * 24 * 3600 * 1000)).toFixed(2);
  return { years, months, totalMonths, decimalYears };
}

export function formatAgeDisplay(dob, now = new Date()) {
  const a = ageFromDOB(dob, now);
  if (!a) return "";
  return `${a.years} year${a.years === 1 ? "" : "s"} ${a.months} month${a.months === 1 ? "" : "s"} (${a.decimalYears} years)`;
}

export function toISODate(dob) {
  if (!dob) return null;
  const d = dob instanceof Date ? dob : new Date(dob);
  if (isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseISODate(iso) {
  if (!iso) return null;
  const d = new Date(iso + "T00:00:00");
  return isNaN(d.getTime()) ? null : d;
}
